var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GrootFooter',{attrs:{"address":_vm.address,"copyright":"© Telia Sverige AB 556430-0142","additionalLinks":_vm.additionalLinks,"navigationLinks":_vm.navigationLinks,"showNavLinks":_vm.showFooterList}})}
var staticRenderFns = []

export { render, staticRenderFns }